import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "../styles/dashboard.css";
import api from '../config/api';

export default function Layout({ children }) {
  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page">
          <Navbar />
          <div className="content-wrapper">{children}</div>
        </div>
      </div>
    </div>
  );
}
